import { styled } from '@mui/material/styles';
import { FormControl, Select, Switch, FormGroup, FormControlLabel} from '@mui/material'
import { ethers } from 'ethers'

const IOS = styled((props) => (
    <Switch  focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2f4a33' : '#2f4a33',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#2f4a33',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.secondary
            : theme.palette.secondary,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#b32d2d' : '#b32d2d',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

export default function IOSSwitch(props){
    const switchPC = props.switchPC;
    const userAccount = props.userAccount;
    const handlePCswitch = props.handlePCswitch; 
    const isMintForm = props.isMintForm;
    const checkedText = props.checkedText;
    const uncheckedText = props.uncheckedText;
    
    if (isMintForm) {
      return(

        <FormControlLabel
        control={
        <IOS onChange={()=>handlePCswitch()} sx={{ m: 1 }} />}
        checked={switchPC == 'Call' ? true : false}
        label={ethers.isAddress(userAccount) ? switchPC : 'Connect wallet'}
        disabled={!ethers.isAddress(userAccount)}
        sx={{paddingBottom: 2}}
    /> );
    } else {
      return(

        <FormControlLabel
        control={
        <IOS onChange={()=>handlePCswitch()} sx={{ m: 1 }} />}
        checked={switchPC == 'Call' ? true : false}
        label={switchPC == "Call" ? checkedText : uncheckedText }
        sx={{paddingBottom: 2}}
    /> );
    }
};